<template>
  <div
    ref="promotions"
    :class="cardClasses"
    v-if="blok.selections>=min_recipes && blok.people==meal_preferences.people"
  >
    <div>
      <b-carousel
        id="carousel-fade"
        style="text-shadow: 0px 0px 2px #000"
        fade
        indicators
        img-width="100%"
        img-height="480"
        class="mb-3"
        :indicators="true"
      >
        <b-carousel-slide
          :key="index"
          v-for="(recipe,index) in recipes_filtered"
          :img-src="recipe.image_urls.l"
        ></b-carousel-slide>
      </b-carousel>
    </div>
    <div class="h3">{{ blok.copy }}</div>
    <div class="h2">
      {{ total | currency('£') }}
      <span
        v-if="this.price_with_discount"
        class="original_price"
      >({{ this.original_price | currency('£') }})</span>
      <span
        class="portion-count"
      >- {{ ((total / meal_preferences.people) / recipes_filtered.length) | currency('£') }} per meal.</span>
    </div>
    <div
      class="promotion-item"
      :key="index"
      v-for="(recipe,index) in recipes_filtered"
    >{{ recipe.title }}</div>
    <button
      @click="selectPromotion"
      class="btn btn-primary btn-secondary my-sm-3 mr-md-2 mt-2 mb-2"
    >{{ customiseLabel ? customiseLabel : 'View Box Contents' }}</button>
    <a :href="buy_url" class="btn btn-primary btn-primary my-sm-3 mb-2">Order This Box</a>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: 'promotion',
    props: {
        blok: Object,
        recipes: Array,
        hoverable: Boolean,
        customiseLink: String,
        customiseLabel: String
    },
    data: () => {
        return {
            style: '',
            price_with_discount: null,
            original_price: null,
            voucher_data: null
        }
    },
    methods: {
        ...mapActions("basket", ["emptyBasket","setVoucher"]),
        ...mapActions("voucher", ["applyVoucher"]),
        ...mapActions("analytics", ["trackSelectPromotion"]),
        selectPromotion: function() {
            const b = this.$props.blok;
            this.emptyBasket();
            this.$emit('selectPromotion',{
                voucher: this.voucher_data,
                selections: b.selections
            });
            this.recipes_filtered.map( v => {
                this.$emit('addToBasket',v);
            });
            if (this.promo_voucher) {
                this.setVoucher(this.promo_voucher);
            };
            this.trackSelectPromotion({
                label: b.copy,
                meal_price: ((this.total / this.meal_preferences.people) / this.recipes_filtered.length),
                price: this.total,
                recipe_count: this.recipes_filtered.length,
                people: this.meal_preferences.people,
                voucher: this.promo_voucher
            })
            if(this.$props.customiseLink) {
                this.$router.push({ path: this.$props.customiseLink })
            }
        },
        updatePrice: function() {
            const ids = this.recipes_filtered.map( v => {
                return v.id
            })
            if(
                this.meal_preferences.shipping_date
                && this.meal_preferences.people
                && this.voucher_code
            ){
                this.applyVoucher({
                    code: this.voucher_code,
                    portion_count: this.meal_preferences.people,
                    delivery_weekday: this.meal_preferences.shipping_date.day,
                    shipping_run: this.meal_preferences.shipping_date.id,
                    recipe_ids: ids.join(",")
                }).then( v => {
                    this.price_with_discount = v.price_with_discount;
                    this.original_price = v.price;
                    this.promo_voucher = v;
                })
            }
        }
    },
    mounted: function() {
        this.updatePrice();
    },
    watch: {
        'meal_preferences.people': function(o,n) {
            this.updatePrice();
        }
    },
    computed: {
        ...mapState({
            meal_preferences: state => state.profile.meal_preferences,
            voucher_code: state => state.voucher.code,
            min_recipes: state => state.basket.config.min_count
        }),
        buy_url: function() {
            const f = this.$options.filters;
            return f.appendLegacyOnboardingQuery(
                    f.formatSbInternalLink(`https://www.mindfulchef.com/onboarding/delivery_details`),
                    this.meal_preferences,
                    { items: this.recipes_filtered.map( v=> {
                        return {
                            recipe: v
                        }
                    }),
                    voucher: {
                        code: this.promo_voucher
                    }
                    }
                )
        },
        promo_voucher: {
            get() {
                return this.$props.voucher_data;
            },
            set(v) {
                this.$props.voucher_data = v;
            }
        },
        styles: function() {
            return ['recipe-image','image-blok','square'];
        },
        cardClasses: function() {
            return [
                'blok-container recipe-card p-3 bg-light promotion'
            ]
        },
        recipes_filtered: function() {
            const b = this.$props.blok;
            const r = [...this.recipes];
            const price = (a,b) => {
                const c = a.fractional_prices_for_portions[this.meal_preferences.people];
                const n = b.fractional_prices_for_portions[this.meal_preferences.people];
                return c-n;
            };
            const random = (a,b) => {
                a.sort = Math.random();
                return a.sort - b.sort;
            };
            const calories = ( (a,b) => {
                const c = a.macros.calories;
                const n = b.macros.calories;
                return c-n;
            });
            let sorted = null;
            switch(b.selector) {
                case "price":
                    sorted = r.sort(price);
                    break;
                case "random":
                    sorted = r.sort(random);
                    break;
                case "calories":
                    sorted = r.sort(calories);
                    break;  
                default:
                    sorted = r;
            };
            return sorted.splice(0,Number(b.selections));
        },
        total: function() {
            const t = this.recipes_filtered.reduce((c,recipe) => {
                const portionPrice = (recipe.fractional_prices_for_portions[this.meal_preferences.people] / 100)
                return c + portionPrice;
            }, 0);
            return this.price_with_discount ? this.price_with_discount : t;
        },
    }
}
</script>
